module.exports = __webpack_public_path__ + "media/assets/img/flags/qu-EC-98832f61a7f99abccb9e574d8424ff2f.png";